/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { 
  Alert, 
  Button, 
  TextField 
} from '@mui/material';

import { 
  CreateContactRequest 
} from '../../redux/actions/contactRequestsActions';

import "./styles.scss";

const ContactPage = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Dispatch the contact request action
      await dispatch(CreateContactRequest(formData, setLoading));
      
      // Reset form and show success message
      setFormData({ name: '', email: '', message: '' });
      setSubmitted(true);
      
      // Hide success message after 5 seconds
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error('Contact form submission failed:', error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
    <div dangerouslySetInnerHTML={{ __html: `<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Contact Us | LusidPay</title>
  <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap" rel="stylesheet">
  <style>
    :root {
      --blue-main: #253f83;
      --blue-btn-hover: #0d67e3;
      --blue-dark: #004182;
      --blue-muted: #56687a;
      --blue-light: #dce6f1;
      --grey-main: #38434f;
      --grey-light: #e9e5df;
      --off-white: #fdfaf5;
      --white: #ffffff;
      --accent-green: #00c49a;
    }
    html, body {
      margin: 0;
      padding: 0;
      background: var(--white);
      color: var(--grey-main);
      font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
      // font-size: 18px;
      line-height: 1.6;
    }
    header {
      width: 100%;
      background: var(--white);
      position: sticky;
      top: 0;
      z-index: 100;
      border-bottom: 1px solid var(--grey-light);
    }
    .nav-container {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 32px;
    }
    .logo img {
      height: 40px;
      display: block;
    }
    nav {
      display: flex;
      gap: 32px;
      align-items: center;
    }
    nav a {
      text-decoration: none;
      color: var(--grey-main);
      font-weight: 500;
      font-size: 1rem;
      padding: 6px 0;
      transition: color 0.15s;
    }
    nav a:hover {
      color: var(--blue-main);
    }
    .cta-nav {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 8px 22px;
      font-weight: 600;
      font-size: 1rem;
      margin-left: 12px;
      text-decoration: none;
      transition: background 0.15s;
      border: none;
      cursor: pointer;
    }
    .cta-nav:hover {
      background: var(--blue-dark);
    }
    .hero {
      background: var(--white);
      text-align: center;
      padding: 90px 20px 40px 20px;
      margin-bottom: 20px;
    }
    .hero h1 {
      font-size: 2.8rem;
      font-weight: 800;
      color: var(--blue-main);
      margin-bottom: 18px;
      letter-spacing: -1px;
    }
    .hero p {
      font-size: 1.25rem;
      color: var(--grey-main);
      margin-bottom: 0;
      max-width: 650px;
      margin-left: auto;
      margin-right: auto;
    }
    .section {
      max-width: 1100px;
      margin: 0 auto 60px auto;
      padding: 0 24px;
    }
    .section-title {
      font-size: 2rem;
      font-weight: 700;
      color: var(--blue-main);
      text-align: center;
      margin-bottom: 36px;
      letter-spacing: -0.5px;
    }
    .contact-row {
      display: flex;
      gap: 40px;
      justify-content: center;
      flex-wrap: wrap;
      margin-bottom: 40px;
    }
    .contact-info, .contact-form {
      background: var(--blue-light);
      border-radius: 16px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
      padding: 32px 28px;
      flex: 1 1 320px;
      min-width: 280px;
      max-width: 420px;
      color: var(--grey-main);
    }
    .contact-info h3 {
      color: var(--blue-main);
      font-size: 1.2em;
      margin-bottom: 16px;
      font-weight: 700;
    }
    .contact-info p {
      margin: 0 0 14px 0;
      color: var(--grey-main);
      font-size: 1.01em;
    }
    .contact-info a {
      color: var(--blue-main);
      text-decoration: underline;
      font-weight: 600;
    }
    .contact-info .contact-socials {
      margin-top: 18px;
      display: flex;
      gap: 18px;
      align-items: center;
    }
    .contact-info .contact-socials a {
      display: inline-block;
      font-size: 1.4em;
      color: var(--blue-main);
      transition: color 0.15s;
    }
    .contact-info .contact-socials a:hover {
      color: var(--blue-dark);
    }
    .contact-form h3 {
      color: var(--blue-main);
      font-size: 1.2em;
      margin-bottom: 16px;
      font-weight: 700;
    }
    .contact-form form {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }
    .contact-form label {
      font-weight: 600;
      color: var(--blue-main);
      margin-bottom: 4px;
    }
    .contact-form input, .contact-form textarea {
      padding: 12px;
      border-radius: 8px;
      border: 1.5px solid var(--blue-light);
      font-size: 1.08em;
      background: var(--white);
      color: var(--grey-main);
      resize: vertical;
    }
    .contact-form textarea { min-height: 80px; }
    .contact-form button {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 20px;
      padding: 12px 0;
      font-size: 1.1em;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin-top: 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 8px rgba(10,102,194,0.06);
    }
    .contact-form button:hover {
      background: var(--blue-dark);
    }
    .contact-success {
      color: var(--accent-green);
      font-weight: 700;
      margin-top: 12px;
      text-align: center;
    }
    .contact-map {
      width: 100%;
      height: 220px;
      border-radius: 14px;
      margin: 18px 0 0 0;
      border: none;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    /* FAQ */
    .contact-faq {
      max-width: 800px;
      margin: 60px auto 0 auto;
      background: var(--blue-light);
      border-radius: 14px;
      padding: 36px 28px;
      box-shadow: 0 2px 8px rgba(10,102,194,0.04);
    }
    .contact-faq h2 {
      color: var(--blue-main);
      margin-bottom: 18px;
      font-size: 1.45em;
      font-weight: 800;
      text-align: center;
    }
    .contact-faq-item {
      margin-bottom: 24px;
    }
    .contact-faq-question {
      color: var(--blue-dark);
      font-weight: 700;
      margin-bottom: 6px;
      font-size: 1.08em;
    }
    .contact-faq-answer {
      color: var(--grey-main);
      font-size: 1.01em;
      margin-bottom: 0;
    }
    .cta-section {
      background: var(--white);
      text-align: center;
      padding: 70px 0 70px 0;
    }
    .cta-section h2 {
      color: var(--blue-main);
      font-size: 2rem;
      margin-bottom: 18px;
      font-weight: 700;
    }
    .cta-section .cta-main {
      background: var(--blue-main);
      color: var(--white);
      border-radius: 10px;
      padding: 16px 46px;
      font-size: 1.1rem;
      font-weight: 700;
      border: none;
      cursor: pointer;
      margin: 0 10px;
      transition: background 0.15s;
      box-shadow: 0 2px 16px rgba(10,102,194,0.06);
    }
    .cta-section .cta-main:hover {
      background: var(--blue-btn-hover);
    }
    footer {
      background: var(--off-white);
      padding: 40px 0;
      text-align: center;
      font-size: 1rem;
      color: var(--blue-muted);
      border-top: 1px solid var(--blue-light);
      letter-spacing: 0.1px;
    }
    @media (max-width: 1000px) {
      .contact-row { flex-direction: column; align-items: center; }
      .section { padding: 0 8px; }
      .contact-faq { padding: 24px 8px; }
    }
  </style>
</head>
<body>

  <section class="hero">
    <h1>Contact Us</h1>
    <p>
      We're here to help! Reach out to LusidPay for product questions, support, partnership inquiries, or just to say hello. Our team responds within one business day.
    </p>
  </section> ` }} />

  
  <section class="section" id="contact-main">
    <div class="contact-row">
      <div class="contact-info">
        <h3>Contact Information</h3>
        <p><strong>Sales:</strong> <a href="mailto:sales@lusid.ai">sales@lusid.ai</a></p>
        <p><strong>Support:</strong> <a href="mailto:support@lusid.ai">support@lusid.ai</a></p>
        <p><strong>Address:</strong><br/>
          LusidPay Inc.<br/>
          11166 Fairfax Blvd Suite 500<br/>
          Fairfax, VA 22030, USA
        </p>
        <p><strong>Hours:</strong><br/>
        Monday – Friday: 8am – 6pm ET</p>

        <iframe class="contact-map"
          src="https://www.google.com/maps?q=11166+Fairfax+Blvd+Suite+500,+Fairfax,+VA+22030,+USA&output=embed"
          allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div class="contact-form">
        <h3>Send Us a Message</h3>
        {/* <form id="contactForm" onsubmit="handleSubmit">
          <label for="name">Name</label>
          <input type="text" id="name" name="name" required>
          <label for="email">Email</label>
          <input type="email" id="email" name="email" required>
          <label for="message">Message</label>
          <textarea id="message" name="message" required></textarea>
          <button type="button">Send Message</button>
        </form>
        <div class="contact-success" id="contactSuccess" style="display:none;">Thank you! We'll be in touch soon.</div> */}
        <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Name"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          required
          margin="normal"
          disabled={loading}
        />
        
        <TextField
          fullWidth
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleInputChange}
          required
          margin="normal"
          disabled={loading}
        />
        
        <TextField
          fullWidth
          label="Message"
          name="message"
          multiline
          value={formData.message}
          onChange={handleInputChange}
          required
          disabled={loading}
          margin="normal"
          sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: 'var(--white)',
            padding: '16px',
            '&:hover fieldset': {
              borderColor: 'var(--blue-main)',
            },
            '& textarea': {
              borderColor: 'white',
              padding: '0px',
              minHeight: '120px !important',
              fontSize: '1.08em',
              lineHeight: '1.5',
              resize: 'vertical'
            }
          },
        }}
        />
        
        <Button
          type="submit"
          variant="contained"
          // color="primary"
          fullWidth
          disabled={loading}
          sx={{ mt: 2 }}
        >
          {loading ? 'Sending...' : 'Send Message'}
        </Button>
        </form>

      {submitted && (
        <Alert
          severity="success" 
          sx={{ mt: 2 }}
        >
          Thank you! We'll be in touch soon.
        </Alert>
      )}
      </div>
    </div>
  </section>

  <div dangerouslySetInnerHTML={{ __html: `
  <section class="contact-faq" id="contact-faq">
    <h2>Frequently Asked Questions</h2>
    <div class="contact-faq-item">
      <div class="contact-faq-question">How do I get started with LusidPay?</div>
      <div class="contact-faq-answer">Contact our sales team or request a demo. We’ll guide you through onboarding and setup.</div>
    </div>
    <div class="contact-faq-item">
      <div class="contact-faq-question">Where can I get support?</div>
      <div class="contact-faq-answer">Email <a href="mailto:support@lusid.ai">support@lusid.ai</a> or use the contact form above. Our team responds within one business day.</div>
    </div>
    <div class="contact-faq-item">
      <div class="contact-faq-question">Can I schedule a personalized demo?</div>
      <div class="contact-faq-answer">Absolutely! Fill out the form or email <a href="mailto:sales@lusid.ai">sales@lusid.ai</a> to book a demo at your convenience.</div>
    </div>
    <div class="contact-faq-item">
      <div class="contact-faq-question">Is LusidPay secure?</div>
      <div class="contact-faq-answer">Yes. We use bank-grade encryption, regular audits, and strict data privacy controls to keep your information safe.</div>
    </div>
    <div class="contact-faq-item">
      <div class="contact-faq-question">Where is LusidPay based?</div>
      <div class="contact-faq-answer">Our headquarters is in Fairfax, Virginia, and we serve customers nationally.</div>
    </div>
  </section>

  <section class="cta-section" id="contact-cta">
    <h2>Want to talk to a real person?</h2>
    <a href="mailto:sales@lusid.ai">
      <button class="cta-main" onclick="window.location='mailto:sales@lusid.ai'">Email Our Team</button>
    </a>
  </section>

  <script>
    // Optional: Show a thank you message on submit (for demonstration only, not real email sending)
    document.getElementById('contactForm').addEventListener('submit', function(e) {
      if(window.location.protocol !== "file:") e.preventDefault();
      document.getElementById('contactSuccess').style.display = "block";
      this.reset();
    });
  </script>
</body>
</html>` }} />
</>
  )
}

export default ContactPage;